import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Row, Col, Accordion } from "react-bootstrap";
import FileWidget from "../../widgets/FileWidget";
import useApp from "../../hooks/useApp";
import useApi from "../../hooks/useApi";
import useReload from "../../hooks/useReload";

const ClientPolicyAttachmentForm = (props) => {
  const { showAlert } = useApp();
  const { api, abortSignal, auth } = useApi();
  const { policy = {} } = props;

  const { toggleReload } = useReload();

  const [showAttachmentForm, setShowAttachmentForm] = useState(false);
  const handleCloseAttachmentForm = () => setShowAttachmentForm(false);
  const handleShowAttachmentForm = () => setShowAttachmentForm(true);

  const [policyAttachment, setPolicyAttachment] = useState({
    name: "",
    attachment: "",
    visible: false,
  });

  const saveAttachment = async (e) => {
    e.preventDefault();

    if (!policyAttachment?.attachment?.length > 0) {
      showAlert("Please select a file to attach", "error");
    } else {
      try {
        //upload the files
        const uploads = [];
        const filesUploaded = [];
        const filesRemoved = [];
        let filesToRemove = [];

        let files = policyAttachment.attachment;

        if (files) {
          let filesRemoving = [];
          let filesRemovingRemote = [];
          let formData = new FormData();
          for (const [key, value] of Object.entries(files)) {
            if (value) {
              formData.append("files", value);
            }
          }

          let fileCount = 0;
          for (const pair of formData.entries()) {
            fileCount += 1;
          }

          if (fileCount) {
            const uploaded = await api.add(
              `/files/upload?destination=policy-attachment`,
              formData
            );

            if (uploaded.ok) {
              const attachment = uploaded?.data[0];

              const data = {
                name: policyAttachment.name,
                location: attachment.path,
                mimetype: attachment.mimetype,
                originalname: attachment.originalname,
                size: attachment.size,
                ClientId: policy.ClientId,
                PolicyId: policy.PolicyId,
                PolicyItemId: policy.id,
                visible: policyAttachment.visible,
              };

              const response = await api.add(`/policy-attachments`, data);
              if (response.ok) {
                setPolicyAttachment({
                  name: "",
                  attachment: "",
                  visible: true,
                });
                showAlert("Policy attachment saved", "success");
                handleCloseAttachmentForm();
                toggleReload();
              }
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <Button
        variant="outline-info me-2"
        size="xs"
        type="button"
        title="Add Attachment"
        onClick={() => handleShowAttachmentForm()}
      >
        Add Attachment <i className="bi bi-paperclip fs-5"></i>
      </Button>
      <Modal
        show={showAttachmentForm}
        onHide={handleCloseAttachmentForm}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Policy Attachments</Modal.Title>
        </Modal.Header>
        <Form autoComplete="off" onSubmit={saveAttachment}>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Attachment name</Form.Label>
              <Form.Control
                autoFocus
                type="text"
                placeholder="Enter name"
                required
                value={policyAttachment?.name || ""}
                onChange={(e) =>
                  setPolicyAttachment({
                    ...policyAttachment,
                    name: e.target.value,
                  })
                }
              />
              <Form.Text className="text-muted">
                Description of attachment
              </Form.Text>
            </Form.Group>
            <Form.Group>
              <Form.Check
                type="switch"
                id="custom-switch"
                label="Visible to client"
                checked={policyAttachment.visible == true ? true : false}
                onChange={(e) =>
                  setPolicyAttachment({
                    ...policyAttachment,
                    visible: e.target.checked,
                  })
                }
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <FileWidget
                multiple={false}
                id="attachment"
                data={[]}
                destination="policy-attachment/"
                onChange={(value) =>
                  setPolicyAttachment({
                    ...policyAttachment,
                    attachment: value,
                  })
                }
                value={
                  policyAttachment?.attachment
                    ? policyAttachment?.attachment
                    : ""
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => handleCloseAttachmentForm()}
            >
              Close
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ClientPolicyAttachmentForm;
